export default {
    namespaced: true,
    state: {
        activeFilters: [],
        iconfilters: [],
        fasttrackenabled: false,
        watersplashesenabled: false,
        ridingwithadultenabled: false,
        showRidingWithAdults: false,
        sliderFilterEnabled: false,
        height: "",
        heightMeasureUnitText: "",
        heightSliderFilterText: "",
    },
    mutations: {
        setFiltersData(state, rootState) {

            state.heightMeasureUnitText = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("HeightMeasureUnitText");
                })
                .map(filtered => {
                    return filtered.HeightMeasureUnitText;
                })[0];

            state.showMeasurementBeforeNumber = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty(
                        "ShowMeasurementBeforeNumber"
                    );
                })
                .map(filtered => {
                    return filtered.ShowMeasurementBeforeNumber;
                })[0];

            state.heightSliderFilterText = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("HeightSliderFilterText");
                })
                .map(filtered => {
                    return filtered.HeightSliderFilterText;
                })[0];

            state.height = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("DefaultSliderValue");
                })
                .map(filtered => {
                    return filtered.DefaultSliderValue;
                })[0];


            state.showRidingWithAdults = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty(
                        "ShowRidingWithAdultsFilter"
                    );
                })
                .map(filtered => {
                    return filtered.ShowRidingWithAdultsFilter;
                })[0];
            state.iconfilters = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("IconFilters");
                })
                .map(filtered => {
                    return filtered.IconFilters;
                })[0];

            let ridingWithAdultIcon = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty(
                        "IconPropertiesFiltersViewModel"
                    );
                })
                .map(filtered => {
                    if (filtered.IconPropertiesFiltersViewModel) {
                        return filtered.IconPropertiesFiltersViewModel.IconFilters.map(
                            filter => {
                                let obj = {};
                                obj.FilterType = filter.FilterType;
                                obj.Icon = filter.Icon;
                                obj.Text = filter.Text;
                                
                                return obj;
                            }
                        )[0];
                    } else {
                        return [];
                    }
                })[0];
            
            if (state.iconfilters) {

                state.dynamicIconFilters = state.iconfilters.filter(filter => {
                    return filter.Key !== null;
                });

                state.hasDynamicIconFilters = state.dynamicIconFilters && state.dynamicIconFilters.length > 0;

                state.fasttrackenabled = state.iconfilters.find(filter => {
                    return filter.FilterType === "FastTrack";
                });

                state.watersplashesenabled = state.iconfilters.find(filter => {
                    return filter.FilterType === "WaterSplashes";
                });

                state.ridingwithadultenabled = state.iconfilters.find(
                    filter => {
                        return filter.FilterType === "RidingWithAdult";
                    }
                );
            } else {
                state.iconfilters = [];
            }
            if (ridingWithAdultIcon)
                state.iconfilters.push(ridingWithAdultIcon);

            state.sliderFilterEnabled = rootState.attractions.filter(attraction => {
                return Boolean(attraction.hasOwnProperty("MeasurementType"));
            })[0];
        },

        filterByHeight(state, height) {
            state.height = height;
        },

        toggleActiveFilters(state, filter) {
            if (!state.activeFilters.includes(filter)) {
                state.activeFilters.push(filter);
            } else if (state.activeFilters.includes(filter)) {
                state.activeFilters = state.activeFilters.filter(
                    el => el !== filter
                );
            }
        },

        setFilterValuesFromCookie(state, payload) {
            if (payload.filters) {
                state.activeFilters = payload.filters;
            }
            if (payload.height) {
                state.height = payload.height;
            }
        }
    },

    getters: {
        getHeight: state => {
            return state.height;
        },
        getMinimumSliderValue: (state, getters, rootState) => {
            if (state.sliderFilterEnabled) {
                return rootState.attractions[0].MinimumSliderValue;
            }
        },
        getMaximumSliderValue: (state, getters, rootState) => {
            if (state.sliderFilterEnabled) {
                return rootState.attractions[0].MaximumSliderValue;
            }
        },
        getMeasurementType: (state, getters, rootState) => {
            if (state.sliderFilterEnabled) {
                return rootState.attractions[0].MeasurementType.charAt(
                    0
                ).toLowerCase();
            }
        },
        getFastTrack: state => {
            window.icons = state.iconfilters;
            return state.iconfilters.filter(icon => icon && icon.FilterType === "FastTrack")[0];
        },
        getWaterSplashes: state => {
            return state.iconfilters.filter(icon => icon && icon.FilterType === "WaterSplashes")[0];
        },
        getSliderIconFilters: state => {
            if (state.sliderFilterEnabled && state.iconfilters) {
                return state.iconfilters.filter(icon => {
                    if (icon && icon.Icon) {
                        return icon.Icon === "RidingWithAdult.svg";
                    }
                })[0];
            }
        },
    }
}